<template lang="pug">
.container
  el-header
    h4
      span {{$t('Network Health Report')}} - {{ currentUserNetwork.name }}
      span.float-right {{ humanTime(currentTime) }}
      br
      //- span.live-update
      //-   el-checkbox(v-model="liveMode") {{ $t('Live Update - Whole Network')}}
    hr.header
  .container-content
    .charts
      .chart(id="HealthMonitoring-activityChart" @click='focusSubject("Activity")', :class='{ selected: focusedSubject === "Activity" }')
        .chart-label {{$t('Activity')}}
        HealthChart.doughnut(
          :dataseries='[desktops.length - desktopsUnHealthy.length - desktopsNotActive.length, desktopsUnHealthy.length, desktopsNotActive.length]',
          :labels='[$t(`Active`), $t(`Disconnected`), $t(`Never Active`)]'
        )
      .chart(id="HealthMonitoring-synchronizationsChart" @click='focusSubject("Synchronizations")', :class='{ selected: focusedSubject === "Synchronizations" }')
        .chart-label {{$t('Synchronizations')}}
        HealthChart.doughnut(
          :dataseries='[$store.state.Device.desktops_affected.length, desktopsUpdatingContentStalled.length, listFailedDownloads.length]',
          :labels='[$t("Not sent"), $t("Stalled"), $t("Failed")]'
        )
      .chart(id="HealthMonitoring-storageChart" @click='focusSubject("Storage")', :class='{ selected: focusedSubject === "Storage" }')
        .chart-label {{$t('Free Storage')}}
        HealthChart.doughnut(
          :dataseries='[desktopsFreeSpace(freeDiskSpaceWarningLimitGB,1000000).length, desktopsFreeSpace(0,freeDiskSpaceAlertLimitGB).length, desktopsFreeSpace(freeDiskSpaceAlertLimitGB,freeDiskSpaceWarningLimitGB).length]',
          :labels='[$t(`Good`), $t(`Danger`), $t(`Warning`)]'
        )
    .lists
      .section(v-if='focusedSubject === "Activity"')
        .subsection
          span {{ $t('Since ')}}
          el-date-picker(id="HealthMonitoring-sinceDatePicker", v-model="startDate", type="date", placeholder="Pick a start day", :picker-options="datePickerOptions")
          span &nbsp;&nbsp;
          span {{ $t('Until')}}
          el-date-picker(id="HealthMonitoring-untilDatePicker", v-model="endDate", type="date", placeholder="Pick a start day", :picker-options="datePickerOptions")
          span.warning(v-if='$moment(startDate).isAfter(endDate, "day")') {{ $t(' Wrong range. Please pick a valid range.')}}
          download-excel(:data = "formatDowntimesForExcel", :title='focusedSubject')
            el-button.float-right(id="HealthMonitoring-activityDownloadExcelButton", type='text', size="mini", :title='$t("Download excel file")')
              font-awesome-icon.medium-icon(icon="download")
        .subsection(v-if='listDowntimes.filter(dt => dt.ongoing === 1).length > 0')
          h4 {{$t('Ongoing disconnections')}}
          .interval.table-header
            .cell-wider.device {{ $t('Device') }}
            .cell-wider.start {{ $t('Disconnected') }}
            .cell-wider.duration {{ $t('Duration (s)') }}
          .interval.body(v-for="(interval, index) of listDowntimes.filter(dt => dt.ongoing === 1)", :class="{ warning: interval.ongoing }", @dblclick.stop="editDevice(interval.Device)")
            .cell-wider.device {{ getDeviceNameByDeviceId(interval.Device) }}
            .cell-wider.start {{ $moment(parseInt(interval.startUTC)).format('YYYY-MM-DD HH:mm:ss') }}
            .cell-wider.duration
              span {{ interval.downtimeseconds ? humanDuration(interval.downtimeseconds * 1000) : '-' }}
        .subsection(v-if='listDowntimes.filter(dt => dt.ongoing === 0).length === 0')
          h4.centered
            p.thumb-up
              font-awesome-icon(icon="thumbs-up")
            p {{$t('No disconnections that started in given period.')}}
        .subsection(v-if='listDowntimes.filter(dt => dt.ongoing === 0).length > 0')
          h4 {{$t('Disconnections that started and ended in given period:')}}
          .interval.table-header
            .cell-wider.device {{ $t('Device') }}
            .cell-wider.start {{ $t('Disconnected') }}
            .cell-wider.end {{ $t('Reconnected') }}
            .cell-wider.duration {{ $t('Duration (s)') }}
          .interval.body(v-for="(interval, index) of listDowntimes.filter(dt => dt.ongoing === 0)", :class="{ warning: interval.ongoing }", @dblclick.stop="editDevice(interval.Device)")
            .cell-wider.device {{ getDeviceNameByDeviceId(interval.Device) }}
            .cell-wider.start {{ $moment(parseInt(interval.startUTC)).format('YYYY-MM-DD HH:mm:ss') }}
            .cell-wider.end {{ !interval.ongoing ? $moment(interval.endUTC).format('YYYY-MM-DD HH:mm:ss') : '-' }}
            .cell-wider.duration
              span {{ interval.downtimeseconds ? humanDuration(interval.downtimeseconds * 1000) : '-' }}
      .section(v-if='focusedSubject === "Synchronizations"')
        .subsection(v-if='desktopsUpdatingContentStalled.length === 0 && listFailedDownloads.length === 0')
          h4.centered
            p.thumb-up
              font-awesome-icon(icon="thumbs-up")
            p {{$t('There are no stalled or failed downloads over the past week.')}}
        .subsection(v-if='desktopsUpdatingContentStalled.length > 0')
          h4 {{$t('Stalled downloads (contact lost during content update):')}}
          download-excel(:data = "formatDownloadsForExcel", :title='focusedSubject')
            el-button.float-right(id="HealthMonitoring-synchDownloadExcelButton", type='text', size="mini", :title='$t("Download excel file")')
              font-awesome-icon.medium-icon(icon="download")
          .interval.table-header
            .cell-wider.device {{ $t('Device - Screen') }}
            .cell-wider.start {{ $t('Started') }}
            .cell-wider.updated {{ $t('Last progress update') }}
            .cell-wider.progress {{ $t('Progress') }}
            .cell-wider.contend-id {{ $t('Content Id') }}
            .cell-wider.hb-contend-id {{ $t('Content Id in last reported HB') }}
          .interval.body(v-for="(download, index) of desktopsUpdatingContentStalled")
            .cell-wider.device {{ getDeviceNameByDeviceId(download.ContentDownloadDeviceDesktop.Device) }}
            .cell-wider.start {{ $moment(parseInt(download.createdAt)).format('YYYY-MM-DD HH:mm:ss') }}
            .cell-wider.updated {{ $moment(parseInt(download.updatedAt)).format('YYYY-MM-DD HH:mm:ss') }}
            .cell-wider.progress {{ download.progress }}%
            .cell-wider.contend-id {{ download.id }}
            .cell-wider.hb-contend-id {{ download.ContentDownloadDeviceDesktop.HBcontentDownloadId }}
        .subsection(v-if='listFailedDownloads.length > 0')
          h4 {{$t('Failed downloads (last 30):')}}
          .interval.table-header
            .cell-wider.device {{ $t('Device - Screen') }}
            .cell-wider.start {{ $t('Started') }}
            .cell-wider.updated {{ $t('Failed') }}
            .cell-wider.progress {{ $t('Progress') }}
            .cell-wider.contend-id {{ $t('Content Id') }}
            .cell-wider.hb-contend-id {{ $t('Content Id in last reported HB') }}
          .interval.body(v-for="(download, index) of listFailedDownloads")
            .cell-wider.device {{ getDeviceByDownload(download) }}
            .cell-wider.start {{ $moment(parseInt(download.createdAt)).format('YYYY-MM-DD HH:mm:ss') }}
            .cell-wider.updated {{ $moment(parseInt(download.updatedAt)).format('YYYY-MM-DD HH:mm:ss') }}
            .cell-wider.progress {{ download.progress }}%
            .cell-wider.contend-id {{ download.id }}
            .cell-wider.hb-contend-id(v-if='$store.state.Device.desktop_list.find(d => d.id === download.ContentDownloadDeviceDesktop)')
              span {{ $store.state.Device.desktop_list.find(d => d.id === download.ContentDownloadDeviceDesktop).HBcontentDownloadId }}
      .section(v-if='focusedSubject === "Storage"')
        .subsection
          span {{ $t('Warning limit GB ')}}
          el-input-number(id="HealthMonitoring-warningLimitInput", v-model="freeDiskSpaceWarningLimitGB")
          span &nbsp;&nbsp;
          span {{ $t('Danger limit GB')}}
          el-input-number(id="HealthMonitoring-dangerLimitInput", v-model="freeDiskSpaceAlertLimitGB")
        .subsection(v-if='noDesktopsLimitedFreeSpace')
          h4.centered
            p.thumb-up
              font-awesome-icon(icon="thumbs-up")
            p {{$t(`All devices have > ` + freeDiskSpaceWarningLimitGB + `GB of free storage`)}}
        .subsection(v-else)
          h4 {{$t('Devices with limited free disk space:')}}
          download-excel(:data = "formatFreeDiskForExcel", :title='focusedSubject')
            el-button.float-right(id="HealthMonitoring-storageDownloadExcelButton", type='text', size="mini", :title='$t("Download excel file")')
              font-awesome-icon.medium-icon(icon="download")
          .interval.table-header
            .cell-wider.device {{ $t('Device') }}
            .cell-wider.start {{ $t('Free Disk GB') }}
          .interval.body(v-for="(desktop, index) of desktopsFreeSpace(1,freeDiskSpaceWarningLimitGB).sort((a, b) => (a.HBfreeDisk > b.HBfreeDisk) ? 1 : 0)", @dblclick.stop="editDevice(desktop.Device.id)")
            .cell-wider.device {{ desktop.Device.name }}
            .cell-wider.start {{ humanFileSize(desktop.HBfreeDisk) }}
  el-dialog(:close-on-click-modal="false", title='', :visible.sync='editDeviceVisible', @close='closeEditDevice()', append-to-body, width='80%')
    EditDevice(v-if='editedDevice', :editedDeviceId='editedDevice.id')
</template>

<script>
import Vue from 'vue'
import textUtils from '../Common/textUtils.mixin'
import userUtils from '../Common/userUtils.mixin'
import HealthChart from './HealthChart'
import NaviButtons from './NaviButtons'
import EditDevice from './AddEditDevice'
import downloadExcel from 'vue-json-excel'

export default {
  mixins: [textUtils, userUtils],
  components: {
    HealthChart,
    NaviButtons,
    downloadExcel,
    EditDevice
  },
  data () {
    return {
      errors: {
      },
      updateTimeIntervalPointer: undefined,
      currentTime: Date.now(),
      hbExpectedIntervalMs: undefined,
      liveMode: false,
      focusedSubject: 'Activity',
      startDate: this.$moment().subtract(1, 'w').format('YYYY-MM-DD'),
      endDate: this.$moment().format('YYYY-MM-DD'),
      listDowntimes: [],
      listFailedDownloads: [],
      editDeviceVisible: false,
      editedDevice: undefined,
      freeDiskSpaceWarningLimitGB: 5,
      freeDiskSpaceAlertLimitGB: 1,
      datePickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        },
        shortcuts: [{
          text: this.$t('Today'),
          onClick (picker) {
            picker.$emit('pick', new Date())
          }
        }, {
          text: this.$t('Yesterday'),
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', date)
          }
        }, {
          text: this.$t('A week ago'),
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', date)
          }
        }, {
          text: this.$t('30 days ago'),
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', date)
          }
        }, {
          text: this.$t('A year ago'),
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 365)
            picker.$emit('pick', date)
          }
        }]
      }
    }
  },
  async created () {
    this.currentTime = Date.now()
    this.hbExpectedIntervalMs = this.currentUserNetwork.inactiveAfterS * 1000
    await this.__getFailedDownloads()
    this.loadList()
  },
  beforeDestroy () {
  },
  watch: {
    liveMode: function (newVal, oldVal) {
      if (newVal === oldVal) return
      if (newVal) {
        this.subscribeToAllDesktops()
      } else {
        this.unsubscribeFromAllDesktops()
      }
      this.__getDesktopsFromDevices()
    },
    startDate: function (newVal, oldVal) {
      if (newVal === oldVal) return
      this.__getDowntimes()
    },
    endDate: function (newVal, oldVal) {
      if (newVal === oldVal) return
      this.__getDowntimes()
    }
  },
  methods: {
    editDevice (deviceId) {
      this.editedDevice = this.$store.state.Device.device_list.find(d => d.id === deviceId)
      this.editDeviceVisible = true
    },
    closeEditDevice () {
      this.editedDevice = undefined
      this.editDeviceVisible = false
    },
    getDeviceByDownload (download) {
      const DeviceDesktop = this.$store.state.Device.desktop_list.find(d => d.id === download.ContentDownloadDeviceDesktop)
      if (DeviceDesktop.Device.name) {
        return DeviceDesktop.Device.name
      }
      const Device = this.$store.state.Device.device_list.find(d => d.id === DeviceDesktop.Device)
      return Device.name
    },
    async focusSubject (subject) {
      this.focusedSubject = subject
      await this.loadList()
    },
    async __getDowntimes () {
      await Vue.axios
        .post(`Downtime/getDowntimes`,
          {
            entity: 'Network',
            entityId: this.currentUserNetwork.id,
            startTimestamp: this.$moment(this.startDate).unix() * 1000,
            endTimestamp: this.$moment(this.endDate).add(24, 'h').unix() * 1000,
            daysFromStartDate: this.$moment().diff(this.$moment().subtract(1, 'w'), 'days')
          }
        )
        .then(response => {
          this.listDowntimes = response.data
        })
    },
    async __getFailedDownloads () {
      await Vue.axios
        .get(`ContentDownload?Network=${this.currentUserNetwork.id}&failed=true&populate=false&sort=createdAt DESC&limit=30`)
        .then(response => {
          this.listFailedDownloads = response.data
        })
    },
    async loadList () {
      if (this.focusedSubject === 'Activity') {
        this.__getDowntimes()
      } else if (this.focusedSubject === 'Synchronizations') {
        this.__getFailedDownloads()
      } else if (this.focusedSubject === 'Storage') {
        console.log('TODO. Get network disks with < 1GB')
      }
    },
    subscribeToAllDesktops () {
      Vue.$io.socket.post('/deviceDesktop/subscribeToDesktops', {
        ids: this.$store.state.Device.desktop_list.map(dt => dt.id)
      })
      Vue.$io.socket.off('devicedesktop')
      Vue.$io.socket.on('devicedesktop', (devicedesktopHB) => {
        this.$store.dispatch('Device/updateDesktopHB', devicedesktopHB)
      })
    },
    unsubscribeFromAllDesktops () {
      Vue.$io.socket.post('/deviceDesktop/unsubscribeFromDesktops', {
        ids: this.$store.state.Device.desktop_list.map(dt => dt.id)
      })
    },
    // FIXME DRY
    desktopUpdatedAt (desktopId) {
      if (this.$store.state.Device.desktop_list.find(dtp => dtp.id === desktopId)) {
        return this.$store.state.Device.desktop_list.find(dtp => dtp.id === desktopId).updatedAt
      }
    },
    // FIXME DRY + EXTEND FILTER TO SAME AS IN LIST
    overdueHB (desktop) {
      if (!this.currentTime) return false
      if (parseInt(desktop.HBTimestamp) === 0) return false
      return desktop.alive === false
    },
    __getDesktopsFromDevices () {
      let desktops = []
      let devicesCloned = JSON.parse(JSON.stringify(this.$store.state.Device.device_list))
      if (!this.liveMode) devicesCloned = this.__filterDevicesByTags(devicesCloned)
      for (const deviceCloned of devicesCloned) {
        const deviceDesktops = this.$store.state.Device.desktop_list.filter(dd => dd.Device === deviceCloned.id)
        for (const deviceDesktop of deviceDesktops) {
          desktops.push({ ...deviceDesktop })
        }
      }
      for (const desktop of desktops) {
        const deviceForDesktop = devicesCloned.find(device => device.id === desktop.Device)
        if (deviceForDesktop) desktop.Device = JSON.parse(JSON.stringify(deviceForDesktop))
      }

      desktops = desktops
        .filter(dtp => dtp.name !== 'headless')
      if (!this.liveMode) desktops = desktops.filter(desktop => this.__filterDesktopByString(desktop))

      desktops.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
      return desktops
    },
    __filterDesktopByString (desktop) {
      if (this.$store.state.Device.search_by_string.length < 1) return true
      if (
        desktop.Device.name.toLowerCase().indexOf(this.$store.state.Device.search_by_string.toLowerCase()) > -1 ||
        desktop.Device.description.toLowerCase().indexOf(this.$store.state.Device.search_by_string.toLowerCase()) > -1 ||
        desktop.name.toLowerCase().indexOf(this.$store.state.Device.search_by_string.toLowerCase()) > -1
      ) return true
      return false
    },
    __filterDevicesByTags (devices) {
      let sideFilter = this.$store.state.Device.device_filter['right']
      if (sideFilter.deviceTags.length > 0) {
        if (!sideFilter.deviceTagsAll) {
          let unionOfDeviceIds = []
          for (let index = 0; index < sideFilter.deviceTags.length; index++) {
            unionOfDeviceIds = [
              ...new Set([
                ...unionOfDeviceIds,
                ...sideFilter.deviceTags[index].device
              ])
            ]
          }
          devices = devices.filter(device =>
            unionOfDeviceIds.includes(device.id)
          )
        } else {
          for (let index = 0; index < sideFilter.deviceTags.length; index++) {
            devices = devices.filter(device =>
              sideFilter.deviceTags[index].device.includes(device.id)
            )
          }
        }
      }
      return devices
    },
    desktopsFreeSpace (fromGB, toGB) {
      return this.desktops.filter(dt => dt.HBTimestamp > 0).filter((dt) => {
        if (dt.HBfreeDisk === null) return false
        const freeGB = Math.round(dt.HBfreeDisk / 1024 / 1024 / 1024)
        return toGB >= freeGB && freeGB >= fromGB
      })
    }
  },
  computed: {
    noDesktopsLimitedFreeSpace () {
      return this.desktopsFreeSpace(0, this.freeDiskSpaceWarningLimitGB).length === 0
    },
    formatDowntimesForExcel () {
      const downtimesPretty = []
      for (const downtime of this.listDowntimes) {
        const downtimePretty = {}
        downtimePretty['Start UTC'] = this.$moment(parseInt(downtime.startUTC)).format('YYYY-MM-DD HH:mm:ss')
        downtimePretty['End UTC '] = this.$moment(parseInt(downtime.endUTC)).format('YYYY-MM-DD HH:mm:ss')
        downtimePretty['Duration'] = downtime.downtimeseconds
        downtimePretty['Is ongoing'] = downtime.ongoing ? this.$t('YES') : '-'
        const deviceInStore = this.$store.state.Device.device_list.find(dd => dd.id === downtime.Device)
        downtimePretty.Device = deviceInStore ? deviceInStore.name : this.$t('Unknown')
        downtimesPretty.push(downtimePretty)
      }
      return downtimesPretty
    },
    formatDownloadsForExcel () {
      const downloadsPretty = []
      for (const desktopStalled of this.desktopsUpdatingContentStalled) {
        const failedDownloadPretty = {}
        const deviceInStore = this.$store.state.Device.device_list.find(d => d.id === desktopStalled.ContentDownloadDeviceDesktop.Device)
        failedDownloadPretty['Screen'] = deviceInStore ? deviceInStore.name : this.$t('Unknown')
        failedDownloadPretty['Started '] = this.$moment(parseInt(desktopStalled.createdAt)).format('YYYY-MM-DD HH:mm:ss')
        failedDownloadPretty['Updated'] = this.$moment(parseInt(desktopStalled.updatedAt)).format('YYYY-MM-DD HH:mm:ss')
        failedDownloadPretty['Progress'] = desktopStalled.progress + '%'
        failedDownloadPretty['Heartbeated Content Id'] = desktopStalled.id
        downloadsPretty.push(failedDownloadPretty)
      }
      for (const failedDownload of this.listFailedDownloads) {
        const failedDownloadPretty = {}
        const desktop = this.$store.state.Device.desktop_list.find(dd => dd.id === failedDownload.ContentDownloadDeviceDesktop)
        const screenName = desktop ? desktop.Device.name : this.$t('Unknown')
        failedDownloadPretty['Screen'] = screenName
        failedDownloadPretty['Started '] = this.$moment(parseInt(failedDownload.createdAt)).format('YYYY-MM-DD HH:mm:ss')
        failedDownloadPretty['Updated'] = this.$moment(parseInt(failedDownload.updatedAt)).format('YYYY-MM-DD HH:mm:ss')
        failedDownloadPretty['Progress'] = failedDownload.progress + '%'
        failedDownloadPretty['Heartbeated Content Id'] = failedDownload.id
        downloadsPretty.push(failedDownloadPretty)
      }
      return downloadsPretty
    },
    formatFreeDiskForExcel () {
      const limitedStorageDesktops = this.desktopsFreeSpace(1, this.freeDiskSpaceWarningLimitGB)
        .sort((a, b) => (a.HBfreeDisk > b.HBfreeDisk) ? 1 : 0)
      const limitedStorageDesktopsPretty = []
      for (const limitedStorageDesktop of limitedStorageDesktops) {
        limitedStorageDesktopsPretty.push(
          {
            'Device Name': limitedStorageDesktop.Device.name,
            'Free storage': this.humanFileSize(limitedStorageDesktop.HBfreeDisk)
          }
        )
      }
      return limitedStorageDesktopsPretty
    },
    desktops () {
      return this.__getDesktopsFromDevices()
    },
    desktopsNotActive () {
      return this.desktops.filter(dt => parseInt(dt.HBTimestamp) === 0)
    },
    desktopsUnHealthy () {
      return this.desktops.filter(dt => this.overdueHB(dt) && parseInt(dt.HBTimestamp) !== 0)
    },
    desktopsUpdatingContent () {
      return this.$store.state.Device.content_downloads.filter((cd) => {
        return cd.progress >= 0 && cd.progress < 100 && !this.overdueHB(cd.ContentDownloadDeviceDesktop)
      })
    },
    desktopsUpdatingContentStalled () {
      return this.$store.state.Device.content_downloads.filter((cd) => {
        return cd.progress >= 0 && cd.progress < 100 && this.overdueHB(cd.ContentDownloadDeviceDesktop)
      })
    },
    desktopsUpdatingContentAlive () {
      return this.$store.state.Device.content_downloads.filter((cd) => {
        return cd.progress >= 0 && cd.progress < 100 && !this.overdueHB(cd.ContentDownloadDeviceDesktop)
      })
    },
    desktopsUpdatingContentFailed () {
      return this.$store.state.Device.content_downloads.filter((cd) => {
        return cd.failed === true
      })
    },
    desktopsUnHealthyPercent () {
      const percentage = Math.round(this.desktopsUnHealthy.length / this.desktops.length * 100)
      if (this.desktopsUnHealthy.length === 0) return ''
      return percentage
    },
    deviceTagFilterHidden () {
      return !this.$store.state.Device.show_tag_filter
    },
    visibleSynchronizations () {
      return this.$store.state.Device.desktops_affected.length > 0 || this.desktopsUpdatingContentStalled.length > 0 || this.desktopsUpdatingContent.length > 0
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.centered {
  margin: 20% 40%;
  width: 500px;
  font-size: 15px;
  text-align: center;
  .thumb-up {
    color: $--color-success;
    font-size: 50px;
  }
}
.container-content {
  display: flex;
  .charts {
    border-right: $--border-light;
    display: flex;
    flex-direction: column;
    width: 220px;
    padding-right: 10px;
    .chart {
      &.selected {
        background-color: $--background-color-selected;
      }
      width: 200px;
      margin-bottom: 20px;
      padding: 10px;
      cursor: pointer;
      .chart-label {
        margin: 0px;
      }
    }
  }
  .lists {
    border: 0px solid pink;
    width: 100%;
    margin-left: 10px
  }
}
.live-update {
  margin-right: 40px;
}
.interval {
  &.hidden {
    display: none;
  }
  &.warning {
    background-color: rgba($--color-danger, 0.2);
  }
  &.table-header {
    margin-bottom: 10px;
    padding: 5px 0px 5px 0px;
    border-top: $--border-light;
    border-bottom: $--border-light;
  }
  &.body {
    margin-bottom: 10px;
    color: $--color-text-secondary;
  }
  display: flex;
  font-size: $--font-size-base;
  .cell {
    width: 25%
  }
  .cell-wider {
    width: 33%;
    border: 0px dotted pink;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Device/HealthMonitoring.vue